// extracted by mini-css-extract-plugin
export var text = "_c-0";